"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("../js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { className: "spectrum-UIIcon-ChevronDownMedium" },
      _react2.default.createElement("path", { d: "M9.99 1.01A1 1 0 0 0 8.283.3L5 3.586 1.717.3A1 1 0 1 0 .3 1.717L4.293 5.7a1 1 0 0 0 1.414 0L9.7 1.717a1 1 0 0 0 .29-.707z", className: "spectrum-UIIcon--medium" }),
      _react2.default.createElement("path", { d: "M11.99 1.51A1 1 0 0 0 10.283.8L6 5.086 1.717.8A1 1 0 1 0 .3 2.217l4.99 4.99a1 1 0 0 0 1.414 0l4.99-4.99a1 1 0 0 0 .296-.707z", className: "spectrum-UIIcon--large" })
    )
  );
};

WrappedIcon.displayName = 'ChevronDownMedium';
exports.default = WrappedIcon;




//////////////////
// WEBPACK FOOTER
// ./node_modules/@react/react-spectrum/Icon/core/ChevronDownMedium.js
// module id = 786
// module chunks = 0